__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "kratosui";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@cx/analytics", "0.1.0", () => (Promise.all([__webpack_require__.e(141), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(1141))))));
			register("@cx/login", "3.0.0", () => (Promise.all([__webpack_require__.e(5), __webpack_require__.e(914), __webpack_require__.e(955)]).then(() => (() => (__webpack_require__(6005))))));
			register("@cx/ui-components", "3.6.3", () => (Promise.all([__webpack_require__.e(341), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(458), __webpack_require__.e(955), __webpack_require__.e(757), __webpack_require__.e(350)]).then(() => (() => (__webpack_require__(8341))))));
			register("@cx/ui", "3.0.2", () => (Promise.all([__webpack_require__.e(677), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(458), __webpack_require__.e(757), __webpack_require__.e(684)]).then(() => (() => (__webpack_require__(8677))))));
			register("@cx/zustand-saga", "0.0.3", () => (__webpack_require__.e(625).then(() => (() => (__webpack_require__(9625))))));
			register("@emotion/react", "11.11.1", () => (Promise.all([__webpack_require__.e(762), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(2762))))));
			register("@emotion/styled", "11.11.0", () => (Promise.all([__webpack_require__.e(578), __webpack_require__.e(914), __webpack_require__.e(458)]).then(() => (() => (__webpack_require__(4578))))));
			register("@hookform/resolvers", "3.10.0", () => (Promise.all([__webpack_require__.e(958), __webpack_require__.e(892)]).then(() => (() => (__webpack_require__(5892))))));
			register("@tanstack/react-query", "5.77.2", () => (Promise.all([__webpack_require__.e(199), __webpack_require__.e(914), __webpack_require__.e(922)]).then(() => (() => (__webpack_require__(6199))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(483), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(2483))))));
			register("react-hook-form", "7.68.0", () => (Promise.all([__webpack_require__.e(965), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(4965))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(194), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(4194))))));
			register("react", "18.3.1", () => (__webpack_require__.e(810).then(() => (() => (__webpack_require__(7810))))));
			register("redux-saga-combine-watchers", "1.0.3", () => (__webpack_require__.e(919).then(() => (() => (__webpack_require__(6919))))));
			register("zod", "3.25.76", () => (__webpack_require__.e(979).then(() => (() => (__webpack_require__(8979))))));
			register("zustand", "4.5.6", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(145)]).then(() => (() => (__webpack_require__(7145))))));
			initExternal(6137);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};